import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { Loader } from "components/Loader";
import AddTaskIcon from "@mui/icons-material/AddTask";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import Checkbox from "@mui/material/Checkbox";
import { DialogBox } from "../DialogBox";
import { useSelector } from "react-redux";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { showToast } from "services/utils/Status";
import { tableRowSx } from "services/constants";
import { customAPI } from "services/utils/CustomAPI";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { tooltipStyleProps } from "services/constants/Styles";
let multiApiCallRestriction = true;
export const Approve = ({
  overTimeDetails,
  listViewPage,
  setListViewPage,
  refreshReCall,
  overTimeKeyPair,
  selectAll,
  setSelectAll,
  loader,
  pendingDetails,
}) => {
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rejectedReasonValidation, setRejectedReasonValidation] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const isDisabled = overTimeKeyPair.name === "Action" || selectedRows.size > 1;
  const isDisabledIcon = selectedRows.size === 0;
  const [buttonLoader, setButtonLoader] = useState(false);
  const [allData, setAllData] = useState([]);
  const [individualData, setIndividualData] = useState([]);
  const containerRef = useRef(null);

  const hasEmptyField = allData.some(
    (row) => row.check_in_datetime === null || row.check_out_datetime === null
  );

  const hasEmptyCheck = individualData.some(
    (row) => row.check_in_datetime === null || row.check_out_datetime === null
  );

  useEffect(() => {
    if (overTimeDetails.length > 0) {
      setSelectedItem(overTimeDetails[0]);
      setSelectedRows(new Set());
    }
  }, [overTimeDetails]);

  const handleDeleteCancel = () => {
    setRejectReason("");
    setOpenRejectDialog(false);
    setRejectedReasonValidation("");
  };

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  const onSubmit = async () => {
    if (rejectReason.trim() === "") {
      setRejectedReasonValidation("Reason");
      return;
    } else if (rejectReason.length < 5) {
      setRejectedReasonValidation("Less than 5 character");
      return;
    }
    try {
      if (selectedRows.size > 1) {
        await handleBulkReject();
      } else {
        await handleReject();
      }
      setOpenRejectDialog(false);
      setRejectedReasonValidation("");
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleApprove = async (department) => {
    if (multiApiCallRestriction) {
      setButtonLoader(true);
      multiApiCallRestriction = false;
      const response = await customAPI(
        `${domain}week-off-approvals/${department.id}/`,
        "PUT",
        {
          status: "Approved",
        }
      );
      if (response.ok) {
        showToast("success", "Week off approved successfully");
        multiApiCallRestriction = true;
        refreshReCall();
        setSelectedItem(null);
      } else {
        multiApiCallRestriction = true;
      }
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [listViewPage]);

  const handleBulkApprove = async () => {
    if (multiApiCallRestriction) {
      if (selectedRows.size === 0) return;
      setButtonLoader(true);
      multiApiCallRestriction = false;
      let approvalData = Array.from(selectedRows);
      const response = await customAPI(
        `${domain}week-off-approvals/batch/`,
        "PUT",
        { ids: approvalData, status: "Approved" }
      );
      if (response.ok) {
        showToast("success", "Week-off approved successfully");
        multiApiCallRestriction = true;
        refreshReCall();

        setSelectedItem(null);
      } else {
        multiApiCallRestriction = true;
      }
      setButtonLoader(false);
    }
  };

  const handleReject = async () => {
    if (multiApiCallRestriction) {
      if (!selectedItem) return;
      setButtonLoader(true);
      multiApiCallRestriction = false;
      const response = await customAPI(
        `${domain}week-off-approvals/${selectedItem.id}/`,
        "PUT",
        {
          status: "Rejected",
          reason: rejectReason,
        }
      );
      if (response.ok) {
        showToast("error", "Week off rejected successfully");
        multiApiCallRestriction = true;
        refreshReCall();
        setSelectedItem(null);
      } else {
        multiApiCallRestriction = true;
      }
      setButtonLoader(false);
    }
  };

  const handleBulkReject = async () => {
    if (multiApiCallRestriction) {
      if (selectedRows.size === 0) return;
      setButtonLoader(true);
      multiApiCallRestriction = false;
      let rejectedData = Array.from(selectedRows);
      const response = await customAPI(
        `${domain}week-off-approvals/batch/`,
        "PUT",
        {
          ids: rejectedData,
          status: "Rejected",
          reason: rejectReason,
        }
      );
      if (response.ok) {
        showToast("error", "Week-off rejected successfully");
        multiApiCallRestriction = true;
        refreshReCall();
        setSelectedItem(null);
      } else {
        multiApiCallRestriction = true;
      }
      setButtonLoader(false);
    }
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);
    setSelectedRows(
      checked ? new Set(overTimeDetails.map((d) => d.id)) : new Set()
    );
    setAllData(checked ? overTimeDetails : []);
  };

  const handleRowSelect = (rowData) => {
    setSelectedRows((prevSelectedRows) => {
      const newSelectedRows = new Set(prevSelectedRows);
      if (newSelectedRows.has(rowData?.id)) {
        newSelectedRows.delete(rowData?.id);
      } else {
        newSelectedRows.add(rowData?.id);
      }
      return newSelectedRows;
    });
    setIndividualData((prevSelectedRows) => {
      const newSelectedRows = new Set(prevSelectedRows);
      if (newSelectedRows.has(rowData)) {
        newSelectedRows.delete(rowData);
      } else {
        newSelectedRows.add(rowData);
      }
      const selectedRowsArray = Array.from(newSelectedRows);
      return selectedRowsArray;
    });
  };

  return loader ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Mui.Grid container xs={12}>
            <Mui.Grid item xs={10.3}></Mui.Grid>
            {selectAll || selectedRows.size > 1 ? (
              <>
                <Mui.Grid
                  item
                  xs={0.7}
                  sx={{
                    pointerEvents:
                      hasEmptyField || hasEmptyCheck ? "none" : "auto",
                    opacity: hasEmptyField || hasEmptyCheck ? 0.8 : 1,
                  }}
                >
                  <CustomButton
                    actionFuntion={() => {
                      handleBulkApprove();
                    }}
                    actionName="Approve"
                    typeName="button"
                    disableAction={buttonLoader}
                  />
                </Mui.Grid>
                <Mui.Grid item xs={0.2}></Mui.Grid>
                <Mui.Grid item xs={0.7}>
                  <CustomButton
                    actionFuntion={() => {
                      setOpenRejectDialog(true);
                    }}
                    actionName="Reject"
                    typeName="button"
                    disabled={isDisabledIcon}
                  />
                </Mui.Grid>
              </>
            ) : null}
          </Mui.Grid>
          <br></br>
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                {overTimeKeyPair.map((header) => (
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                      textAlign: header.name === "Action" ? "center" : "left",
                    }}
                  >
                    {header.key === "checkbox" ? (
                      <Checkbox
                        checked={selectAll}
                        onChange={(event) => {
                          if (
                            checkFirstLevelApproverPermission(
                              userScreenAccess?.module_details,
                              "Approve",
                              "Week Off"
                            )
                          ) {
                            handleSelectAll(event);
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to reject or approve the week off"
                            );
                          }
                        }}
                        size="medium"
                        disabled={
                          overTimeDetails?.length === 0 ||
                          overTimeDetails?.length === 1
                        }
                      />
                    ) : (
                      header.name
                    )}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {overTimeDetails.length === 0 ? (
                <InfoMessage dataLength={pendingDetails} />
              ) : (
                overTimeDetails
                  ?.slice(
                    listViewPage * rowsPerPage,
                    listViewPage * rowsPerPage + rowsPerPage
                  )
                  .map((department) => (
                    <Mui.TableRow key={department.id} sx={tableRowSx}>
                      {overTimeKeyPair.map((header) =>
                        header.name === "" ? (
                          <Mui.TableCell>
                            <Checkbox
                              checked={selectedRows.has(department.id)}
                              onChange={() => {
                                if (
                                  checkFirstLevelApproverPermission(
                                    userScreenAccess?.module_details,
                                    "Approve",
                                    "Week Off"
                                  )
                                ) {
                                  handleRowSelect(department);
                                } else {
                                  showToast(
                                    "error",
                                    "Access denied: You are not authorized to reject or approve the week off"
                                  );
                                }
                              }}
                            />
                          </Mui.TableCell>
                        ) : header.name === "Employee name" ? (
                          <Mui.TableCell sx={{ color: themes.headLine }}>
                            <Mui.Stack direction="Row">
                              <Mui.Avatar
                                sx={{ width: 23, height: 23 }}
                                alt={department?.user_name
                                  ?.charAt(0)
                                  .toUpperCase()}
                                src={department?.image_url ?? optionalAvathar}
                              />
                              <Mui.Typography
                                sx={{
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  paddingLeft: 1,
                                }}
                              >
                                {department?.user_name
                                  ? department?.user_name
                                  : "N/A"}
                              </Mui.Typography>
                            </Mui.Stack>
                          </Mui.TableCell>
                        ) : header.name !== "Action" ? (
                          <Mui.TableCell sx={{ color: themes.headLine }}>
                            {department[header.key]
                              ? department[header.key]
                              : "N/A"}
                          </Mui.TableCell>
                        ) : header.name === "Action" ||
                          selectedRows.size > 1 ? (
                          <Mui.TableCell
                            sx={{
                              textAlign:
                                header.name === "Action" ? "center" : "left",
                            }}
                          >
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title="Approve"
                            >
                              <Mui.IconButton
                                onClick={() => {
                                  if (
                                    checkFirstLevelApproverPermission(
                                      userScreenAccess?.module_details,
                                      "Approve",
                                      "Week Off"
                                    )
                                  ) {
                                    handleApprove(department);
                                  } else {
                                    showToast(
                                      "error",
                                      "Access denied: You are not authorized to approve the week off"
                                    );
                                  }
                                }}
                                disabled={
                                  isDisabled ||
                                  department.check_out_datetime === null
                                }
                                sx={{
                                  color:
                                    department.check_out_datetime === null
                                      ? "gray"
                                      : themes.primaryIndicator,
                                }}
                              >
                                <AddTaskIcon
                                  sx={{
                                    color:
                                      department.check_out_datetime === null
                                        ? "gray"
                                        : themes.primaryIndicator,
                                    strokeWidth: 2,
                                  }}
                                />
                              </Mui.IconButton>
                            </Mui.Tooltip>
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title="Reject"
                            >
                              <Mui.IconButton
                                onClick={() => {
                                  if (
                                    checkFirstLevelApproverPermission(
                                      userScreenAccess?.module_details,
                                      "Approve",
                                      "Week Off"
                                    )
                                  ) {
                                    setSelectedItem(department);
                                    setOpenRejectDialog(true);
                                  } else {
                                    showToast(
                                      "error",
                                      "Access denied: You are not authorized to reject the week off"
                                    );
                                  }
                                }}
                                disabled={isDisabled}
                              >
                                <NotInterestedIcon
                                  sx={{
                                    color: themes.redColor,
                                    strokeWidth: 2,
                                  }}
                                />
                              </Mui.IconButton>
                            </Mui.Tooltip>
                          </Mui.TableCell>
                        ) : null
                      )}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
          {overTimeDetails?.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={overTimeDetails?.length}
              rowsPerPage={rowsPerPage}
              page={listViewPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Mui.TableContainer>
      </Mui.Grid>

      <DialogBox
        open={openRejectDialog}
        onClose={handleDeleteCancel}
        title="Reason for Rejection"
      >
        <Mui.TextField
          multiline
          minRows={3}
          sx={{
            marginTop: 1,
            width: "95%",
            marginLeft: 2,
            marginRight: "auto",
          }}
          placeholder="please enter reason of rejection"
          onChange={(e) => setRejectReason(e.target.value)}
        />
        {rejectedReasonValidation === "Reason" ? (
          <Mui.Typography
            variant="body2"
            color="error"
            sx={{ fontSize: 13, paddingLeft: 3, paddingTop: 0.5 }}
          >
            Please enter the rejected reason
          </Mui.Typography>
        ) : null}
        {rejectedReasonValidation === "Less than 5 character" ? (
          <Mui.Typography color="red" sx={{ paddingLeft: 3 }}>
            Minium 5 character required
          </Mui.Typography>
        ) : null}

        <Mui.Grid container sx={{ paddingTop: 1 }}>
          <Mui.Grid xs={8}></Mui.Grid>
          <Mui.Grid
            xs={4}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingRight: 1,
            }}
          >
            <CustomButton
              actionFuntion={handleDeleteCancel}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton
              actionFuntion={onSubmit}
              actionName="Reject"
              disableAction={
                openRejectDialog && buttonLoader ? buttonLoader : false
              }
              typeName="submit"
            />
          </Mui.Grid>
        </Mui.Grid>
      </DialogBox>
    </React.Fragment>
  );
};
